import Vue from "vue";
import { mutations } from "./store";

import { default as StAlert } from "./StAlert.vue";
import { default as StButton } from "./StButton.vue";
import { default as StCheckbox } from "./StCheckbox.vue";
import { default as StComboBox } from "./StComboBox.vue";
import { default as StConfirm } from "./StConfirm.vue";
import { default as StDivider } from "./StDivider.vue";
import { default as StDropdown } from "./StDropdown.vue";
import { default as StDropdownItem } from "./StDropdownItem.vue";
import { default as StFloat } from "./StFloat.vue";
import { default as StInput } from "./StInput.vue";
import { default as StTooltip } from "./StTooltip.vue";
import { default as StLoading } from "./StLoading.vue";
import { default as StLink } from "./StLink.vue";
import { default as StModal } from "./StModal.vue";

import { default as AwesomeIcon } from "./AwesomeIcon.vue";

export default Vue.mixin({
    methods: {
        $alert(type, message) {
            mutations.pushAlert({ type, message });
        },

        $confirm(info, options) {
            mutations.openConfirm(info, options);
        }
    },
    components: {
        AwesomeIcon,
        StAlert,
        StButton,
        StCheckbox,
        "st-combobox": StComboBox,
        StConfirm,
        StDivider,
        StDropdown,
        StDropdownItem,
        StFloat,
        StInput,
        StTooltip,
        StLoading,
        StLink,
        StModal
    }
});
